import React from 'react';
import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined';
import Warning from '@material-ui/icons/Warning';
import { Trans, useTranslation } from '@michelin/central-provider';
import { VehicleType } from 'types/UFOTypes';
import { getVehicleLabel } from '../SelectVehicle/VehicleSelection';

interface FitWarningProps {
  vehicle?: VehicleType;
  fit: boolean;
}
export const FitWarning = (props: FitWarningProps) => {
  const { vehicle, fit } = props;
  const { t } = useTranslation();

  return (
    <>
      {vehicle && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 10,
            marginBottom: 16,
            marginTop: 8,
          }}
        >
          {fit && <CheckCircleOutlined style={{ float: 'left', marginRight: 4, width: 18 }} color="primary" />}
          {!fit && <Warning style={{ float: 'left', marginRight: 8 }} color="error" />}
          <span>
            <Trans>
              {fit ? t('Fits your') : t('Please note: This product may not fit your')}
              <b>{` ${getVehicleLabel(vehicle)}`}</b>
            </Trans>
          </span>
        </div>
      )}
    </>
  );
};
